<template>
  <Flex direction="column" :gap="12" :padding-y="8">
    <Flex align-x="between" align-y="center">
      <Flex id="paste-diet-scale-label" direction="row" align-y="center" :gap="4">
        Czy chcesz przeskalować jadłospis?
        <HelperTooltip
          content="System proporcjonalnie przeliczy gramatury potraw, aby osiągnąć pożądaną kaloryczność. Przeskalowanie tworzy dokładne wartości po przecinku (np. 14,3 g), co może wymagać ręcznego zaokrąglenia."
        />
      </Flex>
      <ButtonGroup aria-labelledby="paste-diet-scale-label" class="field" color="gray" role="group">
        <Button
          :aria-pressed="!shouldScale"
          :data-ui-state="!shouldScale ? 'pressed' : undefined"
          @click="emit('update:shouldScale', false)"
        >
          Nie
        </Button>
        <Button
          :aria-pressed="shouldScale"
          :data-ui-state="shouldScale ? 'pressed' : undefined"
          @click="emit('update:shouldScale', true)"
        >
          Tak
        </Button>
      </ButtonGroup>
    </Flex>

    <Flex align-x="between" align-y="center">
      <label for="paste-diet-calories">
        Podaj pożądaną kaloryczność jadłospisu<span aria-hidden="true">*</span>
      </label>
      <Input
        id="paste-diet-calories"
        data-test-id="DietDetail__PasteDietModalCalories"
        :error="error"
        :model-value="calories"
        max="9999"
        :disabled="!shouldScale"
        min="0"
        required
        step="1"
        type="number"
        style="width: 140px;"
        @click="emit('caloriesClick')"
        @update:model-value="emit('update:calories', $event)"
      >
        <template #suffix>kcal</template>
      </Input>
    </Flex>
  </Flex>
</template>

<script lang="ts" setup>
  import { Button, ButtonGroup, HelperTooltip, Input } from '@/components/ui'
  import Flex from '@/components/ui/Flex/Flex.vue'

  defineProps<{ calories: string; error?: string; shouldScale: boolean }>()
  const emit = defineEmits<{
    caloriesClick: []
    'update:calories': [value: string]
    'update:shouldScale': [value: boolean]
  }>()
</script>
